export function removeSuffix(input: string, suffix:string): string {
	const suffixPattern = new RegExp(`${suffix}$`)
	return input.replace(suffixPattern, '')
}

export function getPrefix(input: string, separator: string): string | undefined {
	if (!input.includes(separator)) {
		return undefined
	}
	return input.split(separator)[0]
}

export function splitStringOnFirst(input: string, separator = '/') {
	if (!input.includes(separator)) {
		return [ '', input ]
	}
	const [first, ...rest] = input.split(separator)
	const second = rest.join(separator)
	return [ first, second ]
}

export const getLastPathPart = (path: string, separator = '/'): string =>
  path.replace(new RegExp(`${separator}+$`), '').split(separator).pop() ?? ''

export const notEmpty = (value: string | null | undefined): boolean => {
	return value !== null && value !== undefined && value !== ""
}

export function isNotEmpty(value: string | null | undefined): boolean {
	return value !== null && value !== undefined && value.length != 0
}

export function isEmpty(value: string | null | undefined): boolean {
	return !isNotEmpty(value)
}

export function concatLine(value: string, newLine: string): string {
	if (isEmpty(value)) {
		return newLine
	}
	return `${value}\n${newLine}`
}

export function capitalize(str: string): string {
  return [...str][0].toUpperCase() + str.slice(1);
}

export const snakeCase = (str: string): string => {
  return str.split(/(?=[A-Z])/).join('_').toLowerCase()
}

export function singular(word: string | null | undefined): string {
	// Check if the input is a valid string
	if (typeof word !== 'string') {
		return '' // or throw new Error('Invalid input')
	}

	if (word.endsWith('s')) {
		return word.slice(0, -1) // Remove the last character
	}

	return word // Return the original word if it doesn't end with 's'
}

const regex = /\$\{(.*?)\}/g
//const regex = /\$\{(\w+)\}/g

export const getMatches = (input: string): string[] => {
	const matches: string[] = []
	let match: RegExpExecArray | null

	while ((match = regex.exec(input)) !== null) {
		matches.push(match[0])
	}

	return matches
}

export const replacePlaceholders = <T extends { [key: string]: string } | undefined>(
	input: string,
	replacements: T,
	useInvalidKeyPlaceholder: boolean = false
): string => {
	return replacePlaceholdersExt(input, replacements, useInvalidKeyPlaceholder).updatedString
}

// Function to replace placeholders and return updated string and replacement count
export const replacePlaceholdersExt = <T extends { [key: string]: string } | undefined>(
	input: string,
	replacements: T,
	useInvalidKeyPlaceholder: boolean = false
): { updatedString: string, count: number } => {
	let count = 0

	if (replacements === undefined) {
		return { updatedString: input, count: 0 }
	}

	const updatedString = input.replace(regex, (match, key) => {
		count++
		return replacements[key] || (useInvalidKeyPlaceholder ? "<INVALID KEY>" : "")
	})

	return { updatedString, count }
}

export function convertUnixToPostgresTimestamp(unixTimestamp: number): string {
	const date = new Date(unixTimestamp * 1000) // Convert to milliseconds
	return date.toISOString() // Format as ISO 8601 string
}

